export default __webpack_public_path__ + "static/media/close-icon.3998e5d1.svg";